<template>
  <div>
    <FormFilter
      :allow-reset="true"
      :config="{ ...config, listCategory: getListCategory() }"
      is-microsite
      :show-multi-selects="true"
      @filtered="displayResults"
      @has-results="displayPagination"
    />
    <div class="columns is-multiline is-variable">
      <Loading v-if="isLoading" :class="$style.loading" />
      <div
        v-for="(result, index) in displayedResults"
        :key="index"
        class="column is-one-third-desktop is-half-tablet is-full-mobile"
      >
        <JobResultTeaser :result="result" />
      </div>
    </div>
    <Pagination
      v-show="config.loadInitialData || hasResults"
      :config="config.pagination"
      :results="results.length"
      @update="displayPaginatedResults"
    />
  </div>
</template>

<script setup>
import FormFilter from '../FormFilter/FormFilter.vue';
import JobResultTeaser from '../JobResultTeaser/JobResultTeaser.vue';
import Pagination from '../Pagination/Pagination.vue';
import { ListCategory } from '../../globals/constants/formFilter';
import Loading from '../Loading/Loading.vue';
import { ref, computed } from 'vue';

defineProps({
  config: {
    type: Object,
    default: () => {},
  },
});

const results = ref([]);
const displayRange = ref([0, 11]);
const displayedResults = ref([]);
const hasResults = ref(false);
const isLoading = ref(true);

const displayPagination = computed((filterHasResults) => {
  return filterHasResults && hasResults.value === true;
});

const displayResults = (newResults) => {
  results.value = newResults;
  displayedResults.value = [];
  isLoading.value = false;
  hasResults.value = newResults.length > 0;

  for (let i = 0; i < newResults.length; i++) {
    if (i >= displayRange.value[0] && i <= displayRange.value[1]) {
      displayedResults.value.push(results.value[i]);
    } else if (i > displayRange.value[1]) {
      break;
    }
  }
};

const displayPaginatedResults = (newDisplayRange) => {
  displayRange.value = newDisplayRange;
  displayResults(results.value);
};

const getListCategory = () => {
  return ListCategory.JOBS;
};
</script>

<style module lang="scss" src="./CornerstoneJobsList.scss" />
